import api from './api'
import type { AvailableSlot } from './clients'

export interface TrainingPair {
  id: string
  trainer_id: string
  partner?: { id: string; name: string }
  members?: { id: string; name: string }[]
}
export interface PairProposal {
  id: string
  slot_id: string | null
  trainer_id: string
  date: string
  start_time: string
  end_time: string
  status: 'pending' | 'accepted' | 'declined' | 'expired' | 'cancelled'
  deadline: string
  awaiting_my_response: boolean
  initiator_name: string
  responder_name: string
}
export interface PairSlot extends AvailableSlot {
  pending: boolean
}
export const getTrainerPairs = async () => (await api.get<{pairs: TrainingPair[]}>('/pairs/trainer')).data.pairs
export const assignPair = async (a: string, b: string) => (await api.post('/pairs/trainer', {client_a_id:a,client_b_id:b})).data
export const removePair = async (id: string) => api.delete(`/pairs/trainer/${id}`)
export const getMyPairs = async () => (await api.get<{pairs:TrainingPair[];proposals:PairProposal[]}>('/pairs/me')).data
export const getPairSlots = async (id: string) => (await api.get<{slots:PairSlot[]}>(`/pairs/slots/${id}`)).data.slots
export const proposePair = async (trainerId:string, slotId:string) => (await api.post<PairProposal>('/pairs/proposals',{trainer_id:trainerId,slot_id:slotId})).data
export const respondPair = async (id:string, action:'accept'|'decline'|'cancel') => (await api.post<PairProposal>(`/pairs/proposals/${id}/respond`,{action})).data
